import type { IntegrationSoftware, StatusesByField } from 'business/types';
import type { DataCatalogField } from 'modules/datacatalog/types';

const shouldDisplayStatus = (
    fieldData: DataCatalogField,
    allIntegrationSoftware: Set<IntegrationSoftware>,
): boolean =>
    fieldData.statusAffectedSoftware?.some((affectedSoftware) =>
        allIntegrationSoftware.has(affectedSoftware as IntegrationSoftware),
    ) ?? true;
/**
 * @returns Statuses that have to be displayed (keyed by their field) :
 * their affected software is in the integration.
 * If no affected software is specified for a field,
 * its status should be displayed.
 */
export const getDisplayedFieldStatuses = (
    dataCatalogFields: DataCatalogField[] | undefined,
    allIntegrationSoftware: Set<IntegrationSoftware> | undefined,
): StatusesByField | undefined => {
    if (!dataCatalogFields || !allIntegrationSoftware) {
        return undefined;
    }

    const statusesByField = Object.fromEntries(
        dataCatalogFields
            .filter((fieldData) =>
                shouldDisplayStatus(fieldData, allIntegrationSoftware),
            )
            .map((fieldData) => [fieldData.field, fieldData.lifeCycleStatus]),
    );

    return statusesByField;
};
